<template>
  <div class="notification row no-gutters align-items-center">
    <div class="col-auto text-center border-right p-3">
      <img src="@/assets/logo.png" />
    </div>
    <div class="col my-2 p-3">
      <h4 class="m-0">
        {{ $t("greeting") }}
      </h4>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    props: {
      entity: {
        type: Object,
        required: true
      },
      action: {
        type: String,
        required: true
      }
    }
  }
}
</script>

<style lang="scss">
.notification {
  img {
    width: 75px;
  }
}
</style>
<i18n>
{
  "ka": {
    "greeting": "MyDoc მოგესალმებათ!"
  },
  "en": {
    "greeting": "Wecome to MyDoc!"
  }
}
</i18n>
